import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import ScrollToTop from "./ScrollToTop";

import "react-toastify/dist/ReactToastify.css";
import "react-block-ui/style.css";

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <ToastContainer />
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
